<template>
  <div class="select-box">
    <div
      v-for="(item, index) in dataList"
      :key="index"
      class="select-item"
      :class="{active: current === index}"
      @click="select(index)"
    >
      {{ item.value }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      required: true
    },
    value: {
      type: [Number, String],
      default: undefined
    }
  },
  data() {
    return {
      current: undefined
    };
  },
  watch: {
    value() {
      this.getCurrent();
    },
    dataList() {
      this.getCurrent();
    }
  },
  mounted() {
    this.getCurrent();
  },
  methods: {
    getCurrent() {
      this.current = this.dataList.map(item => item.key).indexOf(String(this.value));
    },
    select(index) {
      this.current = index;
      this.$emit('update:value', this.dataList[index].key);
    }
  }
};
</script>

<style lang="scss" scoped>
.select-box{
  display: flex;
  flex-wrap: wrap;

  margin: 16px 0 -10px -10px;
  .select-item {
    min-width: 30px;
    margin: 0 0 10px 10px;
    padding: 5px 10px;

    text-align: center;
    letter-spacing: -0.38px;

    color: #646464;
    border-radius: 4px;
    background: #E1E7ED;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.active{
      color: #ffffff;
      background: #3399FF;
    }
  }
}
</style>
